import { useEffect, useState } from 'react';
import { getDictionaryAction } from '@/app/api/products/actions';

export const useClientTranslation = (locale: string, namespace: string) => {
    const [translation, setTranslation] = useState<{
        [key: string]: string;
    } | null>(null);
    const [loading, setLoading] = useState<boolean>(true);
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        const fetchTranslation = async () => {
            try {
                const result = await getDictionaryAction(locale, namespace);
                setTranslation(result);
            } catch (err) {
                setError('Failed to load translation.' + err);
            } finally {
                setLoading(false);
            }
        };

        fetchTranslation();
    }, [locale, namespace]);

    return { translation, loading, error };
};
